const healthKitExerciseTypes = {
  archery: 'Bogenschiessen',
  bowling: 'Bowling',
  fencing: 'Fechten',
  gymnastics: 'Gymnastik',
  trackAndField: 'Leichtathletik',
  americanFootball: 'Football',
  australianFootball: 'Australisches Football',
  baseball: 'Baseball',
  basketball: 'Basketball',
  cricket: 'Cricket',
  discSports: 'Frisbee',
  handball: 'Handball',
  hockey: 'Hockey',
  lacrosse: 'Lacrosse',
  rugby: 'Rugby',
  soccer: 'Fussball',
  softball: 'Softball',
  volleyball: 'Volleyball',
  preparationAndRecovery: 'Aufwärmen und Erholung ',
  flexibility: 'Dehnen',
  cooldown: 'Cooldown',
  walking: 'Gehen',
  running: 'Joggen',
  wheelchairWalkPace: 'Rollstuhl (Gehtempo)',
  wheelchairRunPace: 'Rollstuhl (Lauftempo)',
  cycling: 'Fahrrad/Velo fahren',
  handCycling: 'Handbike',
  coreTraining: 'Core-Workout',
  elliptical: 'Crosstrainer',
  functionalStrengthTraining: 'Funktionelles Krafttraining',
  traditionalStrengthTraining: 'Klassisches Krafttraining',
  crossTraining: 'Crosstraining',
  mixedCardio: 'Gemischtes Ausdauertraining',
  highIntensityIntervalTraining: 'Hochintensives Intervalltraining (HIT)',
  jumpRope: 'Seilspringen',
  stairClimbing: 'Treppensteigen',
  stairs: 'Treppen',
  stepTraining: 'Stepper',
  fitnessGaming: 'Fitness-Game',
  barre: 'Barre-Workout',
  cardioDance: 'Dance-Workout',
  socialDance: 'Gesellschaftstanz',
  yoga: 'Yoga',
  mindAndBody: 'Mind-Body-Fitness',
  pilates: 'Pilates',
  badminton: 'Badminton',
  pickleball: 'Pickleball',
  racquetball: 'Racquetball',
  squash: 'Squash',
  tableTennis: 'Tischtennis',
  tennis: 'Tennis',
  climbing: 'Klettern',
  equestrianSports: 'Reitsport',
  fishing: 'Angeln',
  golf: 'Golf',
  hiking: 'Wandern',
  hunting: 'Jagen',
  play: 'Spielen',
  crossCountrySkiing: 'Skilanglauf',
  curling: 'Curling',
  downhillSkiing: 'Abfahrtsski',
  snowSports: 'Wintersport',
  snowboarding: 'Snowboarden',
  skatingSports: 'Skating',
  paddleSports: 'Paddeln',
  rowing: 'Rudern',
  sailing: 'Segeln',
  surfingSports: 'Surfen',
  swimming: 'Schwimmen',
  underwaterDiving: 'Tauchen',
  waterFitness: 'Wassergymnastik',
  waterPolo: 'Wasserball',
  waterSports: 'Wassersport',
  boxing: 'Boxen',
  kickboxing: 'Kickboxen',
  martialArts: 'Kampfsport',
  taiChi: 'Tai Chi',
  wrestling: 'Ringen',
  other: 'Sonstiges',
  swimBikeRun: 'Triathlon',
  transition: 'Wechselphase'
}

export default healthKitExerciseTypes
